module.exports = __webpack_public_path__ + "img/2.00cfa9a9.png";